"use client";

import { useSearchParams } from "next/navigation";
import { useRouter } from "@i18n/routing";
import { useEffect } from "react";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";

/**
 * Handles showing the login modal after navigation from reset password.
 * Detects `?showLogin=true` query param and triggers the login modal.
 * Must be rendered as a child of GlobalModalProvider.
 */
export function ShowLoginHandler() {
    const searchParams = useSearchParams();
    const router = useRouter();
    const { showModal, isReady } = useGlobalModalContext();

    useEffect(() => {
        const shouldShowLogin = searchParams.get("showLogin") === "true";

        if (shouldShowLogin && isReady) {
            showModal(ModalTypes.login);
            // Clean up URL by removing the param
            const url = new URL(window.location.href);
            url.searchParams.delete("showLogin");
            router.replace(url.pathname + url.search, { scroll: false });
        }
    }, [searchParams, showModal, isReady, router]);

    return null;
}
